import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeSubtype = async ({ docId, subTypeId }) => {
  return await request.put(
    `/Docs/subtype/${docId}`,
    null,
    'При изменении подтипа документа произошла ошибка',
    'Error',
    null,
    { subTypeId }
  );
};

const useChangeSubtype = () =>
  useMutation(changeSubtype, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

export default useChangeSubtype;
